import { render, staticRenderFns } from "./AdminsDetails.vue?vue&type=template&id=9af68c06&"
import script from "./AdminsDetails.vue?vue&type=script&lang=js&"
export * from "./AdminsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports